module.exports = __webpack_public_path__ + "img/agent-plugin.88586899.png";